import React from 'react'; // we need this to make JSX compile
import './BrowserUpgrade.scss';

type props = {
    className: string,
    pcomment: string
}

export const BrowserUpgrade = {

    upgrd: ({ className, pcomment }: props) => {
    
        return  <p className={className}>
                    {pcomment}
                </p> 
    }
}
export default BrowserUpgrade